import { render, staticRenderFns } from "./orderdetailIndex.vue?vue&type=template&id=01c24cce&scoped=true&"
import script from "./orderdetailIndex.vue?vue&type=script&lang=js&"
export * from "./orderdetailIndex.vue?vue&type=script&lang=js&"
import style0 from "./orderdetailIndex.vue?vue&type=style&index=0&id=01c24cce&prod&lang=scss&scoped=true&"
import style1 from "./orderdetailIndex.vue?vue&type=style&index=1&id=01c24cce&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c24cce",
  null
  
)

export default component.exports